import { connect } from 'react-redux';
import PinnedPostCard from './PinnedPostCard';
import { selectors } from '../../../../../../../store/reactions';
import { commentCount } from '../../../../../../../../core/selectors/comments';
import { openPost } from '../../../../../../../actions/navigation';

const makeMapStateToProps = () => {
  const { getReactionsCountSelector, getReactionsSelector } = selectors;
  const getReactionsCount = getReactionsCountSelector(getReactionsSelector());
  return (state, props) => ({
    reactionsCount: getReactionsCount(state, { itemId: props.postId }),
    commentsCount: commentCount(state, props.postId),
  });
};

const mapDispatchToProps = {
  openPost,
};

const Reactions = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(PinnedPostCard);

export default Reactions;
